import { render, staticRenderFns } from "./ProgramSidebar.vue?vue&type=template&id=1c8ffec4&scoped=true&"
import script from "./ProgramSidebar.vue?vue&type=script&lang=js&"
export * from "./ProgramSidebar.vue?vue&type=script&lang=js&"
import style0 from "./ProgramSidebar.vue?vue&type=style&index=0&id=1c8ffec4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c8ffec4",
  null
  
)

export default component.exports